var global = require('../internals/global');
var classof = require('../internals/classof');

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-string.js
// module id = 18
// module chunks = 49